import { round } from "lodash";
import dateService from "../../../../../../../../common/utils/date/date.service";
import uuidService from "../../../../../../../../common/utils/uuid/uuid.service";
import MileageAddSummaryRouteWaypoint from "../types/mileage-add-summary-route-waypoint";

const getPlaceLabel = (place: MileageAddSummaryRouteWaypoint["place"]) => {
  if (place === null) {
    return `----`;
  }

  return place.displayName;
};

const getPlaceTitle = (place: MileageAddSummaryRouteWaypoint["place"]) => {
  if (place === null) {
    return undefined;
  }

  return place.displayName;
};

const getDistanceLabel = (
  distance: MileageAddSummaryRouteWaypoint["distance"],
): string => {
  if (distance === null) {
    return `0 KM`;
  }

  const distanceAsKm = round(distance / 1000, 0);

  return `${distanceAsKm} KM`;
};

const getTimeLabel = (time: MileageAddSummaryRouteWaypoint["time"]) => {
  if (time === null || !dateService.checkIsValidDate(time)) {
    return `---`;
  }

  return dateService.formatDateTime(time);
};

const generateWaypointDotClassname = (
  waypoint: MileageAddSummaryRouteWaypoint,
) => {
  return `dot-uuid-${waypoint.uuid ?? uuidService.generate()}`;
};

const mileageAddSummaryRouteHelper = {
  getPlaceLabel,
  getPlaceTitle,
  getDistanceLabel,
  getTimeLabel,
  generateWaypointDotClassname,
};

export default mileageAddSummaryRouteHelper;
